import { CIcon } from '~/icons/types'

export const ciPlay: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18.232 10.317 7.082 3.15A1.999 1.999 0 0 0 4 4.832v14.336a2 2 0 0 0 3.082 1.683l11.151-7.169a1.997 1.997 0 0 0-.001-3.365ZM6 19.168V4.832L17.15 12 6 19.168Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'play',
  type: 'regular'
}
